module.exports = __webpack_public_path__ + "static/img/__9001.aa28481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9001.jpg
// module id = fwSR
// module chunks = 0